import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { SEO } from "@/components/SEO";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-[70vh] flex items-center justify-center px-6">
      <SEO title="Payment Cancelled" description="Payment cancelled" />
      <div className="bg-taupe rounded-3xl p-12 max-w-lg w-full text-center">
        <XCircle className="mx-auto text-espresso/60" size={48} />
        <h1 className="font-serif text-3xl text-espresso mt-6">Checkout cancelled.</h1>
        <p className="text-espresso/70 mt-3">No charges were made. Whenever you're ready, you can pick up right where you left off.</p>
        <Link to="/pricing" className="inline-block mt-8 bg-espresso text-ivory rounded-full px-7 py-3 font-medium hover:bg-forest transition-colors" data-testid="cancel-pricing">Return to Pricing</Link>
      </div>
    </div>
  );
}
